var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "label-modal",
    attrs: {
      title: _vm.$t("添加字典项"),
      visible: _vm.visible,
      width: 800
    },
    on: {
      cancel: _vm.closeAddVisible
    }
  }, [_c("a-form-model", {
    ref: "addFormRef",
    attrs: {
      model: _vm.addForm,
      rules: _vm.addRules,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("字段名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.addForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "name", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("字段代码"),
      prop: "code"
    }
  }, [_c("a-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.addForm.code,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "code", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.code"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("分类"),
      prop: "field_category"
    }
  }, [_c("a-select", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.addForm.field_category,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "field_category", $$v);
      },
      expression: "addForm.field_category"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "insurance_template"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("投保模板")) + " ")]), _c("a-select-option", {
    attrs: {
      value: "claims_param"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("理赔参数")) + " ")])], 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("选项值"),
      required: ""
    }
  }, [_c("a-table", {
    attrs: {
      columns: _vm.dictionaryColumns,
      "data-source": _vm.dictionaryData,
      rowKey: "index",
      pagination: false
    },
    scopedSlots: _vm._u([{
      key: "key",
      fn: function (text, record, index) {
        return [_c("a-form-item", {
          staticStyle: {
            "margin-bottom": "0"
          },
          attrs: {
            label: "",
            "validate-status": _vm.errorCell["key" + index] ? "error" : "success"
          }
        }, [_c("a-input", {
          attrs: {
            placeholder: _vm.$t("请输入") + _vm.$t("值标识"),
            allowClear: "",
            "max-length": 50
          },
          on: {
            change: e => _vm.changeInputValue(e, "key" + index)
          },
          model: {
            value: _vm.dictionaryData[index]["key"],
            callback: function ($$v) {
              _vm.$set(_vm.dictionaryData[index], "key", $$v);
            },
            expression: "dictionaryData[index]['key']"
          }
        })], 1)];
      }
    }, {
      key: "value",
      fn: function (text, record, index) {
        return [_c("a-form-item", {
          staticStyle: {
            "margin-bottom": "0"
          },
          attrs: {
            label: "",
            "validate-status": _vm.errorCell["value" + index] ? "error" : "success"
          }
        }, [_c("a-input", {
          attrs: {
            placeholder: _vm.$t("请输入") + _vm.$t("字典值"),
            allowClear: "",
            "max-length": 30
          },
          on: {
            change: e => _vm.changeInputValue(e, "value" + index)
          },
          model: {
            value: _vm.dictionaryData[index].value,
            callback: function ($$v) {
              _vm.$set(_vm.dictionaryData[index], "value", $$v);
            },
            expression: "dictionaryData[index].value"
          }
        })], 1)];
      }
    }, {
      key: "action",
      fn: function (text, record, index) {
        return [_c("a-button", {
          staticClass: "marginR15",
          attrs: {
            size: "small",
            disabled: _vm.dictionaryData.length === 1,
            type: "danger"
          },
          on: {
            click: function ($event) {
              return _vm.deleteLine(index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))])];
      }
    }])
  }, _vm._l(_vm.dictionaryColumns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("a-button", {
    staticClass: "marginR15 add-line-class",
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.addLine();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("新增")))])], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      size: "small",
      loading: _vm.saveLoading,
      disabled: _vm.saveLoading
    },
    on: {
      click: _vm.saveAdd
    }
  }, [_vm._v(" " + _vm._s(_vm.saveLoading ? "" : _vm.$t("确认")) + " ")])], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };